import { ReactComponent as Launchpad } from "../Features/Admin/AdminAssets/svg/LaunchPad.svg";
import { ReactComponent as GrowthGear } from "../Features/Admin/AdminAssets/svg/GrowthGear.svg";
import { ReactComponent as Momentum } from "../Features/Admin/AdminAssets/svg/Momentum.svg";
import { ReactComponent as Booster } from "../Features/Admin/AdminAssets/svg/Booster.svg";
import { ReactComponent as ToTheMoon } from "../Features/Admin/AdminAssets/svg/ToTheMoon.svg";

import { ReactComponent as Launchpad1 } from "../Features/Admin/AdminAssets/svg/LaunchPadDark.svg";
import { ReactComponent as GrowthGear1 } from "../Features/Admin/AdminAssets/svg/GrowthGearDark.svg";
import { ReactComponent as Momentum1 } from "../Features/Admin/AdminAssets/svg/MomentumDark.svg";
import { ReactComponent as Booster1 } from "../Features/Admin/AdminAssets/svg/BoosterDark.svg";
import { ReactComponent as ToTheMoon1 } from "../Features/Admin/AdminAssets/svg/ToTheMoonDark.svg";

// const blackBackground = (Component) => {
//   return (props) => {
//     return (
//       <div style={{ backgroundColor: "#000000", borderRadius: "6px" }}>
//         <Component {...props} />
//       </div>
//     );
//   };
// };

export const planIcons = {
  LaunchPad: Launchpad1,
  GrowthGear: GrowthGear1,
  Momentum: Momentum1,
  Booster: Booster1,
  ToTheMoon: ToTheMoon1,
  "Dedicated Hosting": Launchpad1,
};
export const planIcon = {
  LaunchPad: Launchpad,
  GrowthGear: GrowthGear,
  Momentum: Momentum,
  Booster: Booster,
  ToTheMoon: ToTheMoon,
  "Dedicated Hosting": Launchpad,
};